import { useEffect, useState } from "react";
import orbitO from "@/assets/orbit-o.png";
import wordmarkText from "@/assets/orbit-wordmark-text.png";
import orbitOOffice from "@/assets/orbit-o-office.png";
import wordmarkTextOffice from "@/assets/orbit-wordmark-text-office-full.png";

// Palette onde: Lavoratore (azzurro) e Ufficio (lilla).
const WAVES = {
  worker: ["#E3EDF5", "#CBDEEC", "#A9C7DD", "#7FA3BF", "#557A95"],
  office: ["#EFE9F7", "#DED3EF", "#C4B7E6", "#A99BD6", "#8478C4"],
};
const D = [
  "M0,120 C70,95 120,152 210,138 C300,125 380,40 500,25 L500,470 L0,470 Z",
  "M0,175 C90,150 165,118 235,165 C320,215 405,58 500,35 L500,470 L0,470 Z",
  "M0,235 C60,258 145,302 245,272 C345,244 420,178 500,215 L500,470 L0,470 Z",
  "M0,332 C85,300 175,326 252,356 C352,392 430,300 500,278 L500,470 L0,470 Z",
  "M0,300 C95,332 185,402 285,376 C385,352 442,398 500,360 L500,470 L0,470 Z",
];
function Waves({ colors }) {
  return (
    <div className="absolute inset-x-0 bottom-0 h-[55%] overflow-hidden pointer-events-none">
      <svg viewBox="0 0 500 470" preserveAspectRatio="none" className="absolute bottom-0 left-0 h-full w-full">
        {D.map((d, i) => <path key={i} d={d} fill={colors[i]} />)}
      </svg>
    </div>
  );
}

// Copertina introduttiva post-login (Opzione 1 approvata). Animazioni CSS (compositor)
// per restare fluide anche mentre la Home pesante monta sotto. Fade out verso la Home.
// variant: "worker" (azzurro) | "office" (lilla).
export function IntroCover({ onDone, variant = "worker" }) {
  const [leaving, setLeaving] = useState(false);
  const isOffice = variant === "office";
  const oImg = isOffice ? orbitOOffice : orbitO;
  const wmImg = isOffice ? wordmarkTextOffice : wordmarkText;
  const bg = isOffice ? "#F7F5FC" : "#F8FAFC";
  const glow = isOffice ? "rgba(225,222,238,0.9)" : "rgba(224,242,254,0.9)";

  useEffect(() => {
    const t1 = setTimeout(() => setLeaving(true), 2250);
    const t2 = setTimeout(() => onDone && onDone(), 2800);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [onDone]);

  return (
    <div
      data-testid="intro-cover"
      className="fixed inset-0 z-[80] flex items-center justify-center"
      style={{ opacity: leaving ? 0 : 1, transition: "opacity 0.55s ease-in-out", background: bg }}
    >
      <div className="absolute inset-0" style={{ backgroundImage: `radial-gradient(circle at 50% 38%, ${glow}, transparent 55%)` }} />
      <Waves colors={isOffice ? WAVES.office : WAVES.worker} />
      <div className="intro-lockup relative" style={{ width: "252px", height: "97px" }}>
        <img
          src={oImg} alt="" draggable="false"
          className="intro-o absolute object-contain select-none"
          style={{ left: "0%", top: "0%", width: "32.9%" }}
        />
        <img
          src={wmImg} alt="Orbit" draggable="false"
          className="absolute object-contain select-none"
          style={{ left: "37.4%", top: "0%", width: "62.6%" }}
        />
        {/* shine mascherato dall'alpha del logo: colpisce SOLO i glifi (O + scritta), non lo sfondo né gli spazi */}
        <div className="intro-shine-wrap absolute" style={{ left: "0%", top: "0%", width: "32.9%", height: "100%", WebkitMaskImage: `url(${oImg})`, maskImage: `url(${oImg})`, WebkitMaskSize: "contain", maskSize: "contain", WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat", WebkitMaskPosition: "left top", maskPosition: "left top" }}>
          <div className="intro-shine intro-shine-o" />
        </div>
        <div className="intro-shine-wrap absolute" style={{ left: "37.4%", top: "0%", width: "62.6%", height: "100%", WebkitMaskImage: `url(${wmImg})`, maskImage: `url(${wmImg})`, WebkitMaskSize: "contain", maskSize: "contain", WebkitMaskRepeat: "no-repeat", maskRepeat: "no-repeat", WebkitMaskPosition: "center", maskPosition: "center" }}>
          <div className="intro-shine intro-shine-wm" />
        </div>
      </div>
    </div>
  );
}
